import gql from 'graphql-tag';
import { query } from 'services/graphql';
import { surfaceUnionReferencesFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-union-references-fragment';

export const surfaceNodeWithReferencesQuery = gql`
  query surfaceNodeWithReferences($id: ID!) {
    surfaceNode(id: $id) {
      success
      error
      data {
        ...surfaceUnionReferences
      }
    }
  }
  ${surfaceUnionReferencesFragment}
`;

export default query(surfaceNodeWithReferencesQuery);
